module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "سميرة-حمادي"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Dubai"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سميرة حمادي")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سميرة حمادي، كاتبة، ومُستشارة في (الإتيكيت)، ومُدرِّبةُ حياةٍ مُعتَمَدة مِن معهَد (إميلي بوست).")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هي أيضًا مُؤسِّسةُ شركةِ استشاراتِ (الإتيكيت) الحديثة؛ حيثُ تُقدِّم استشاراتٍ وتدريباتٍ للمؤسَّسات والأفرادِ مِن جميع الأعمارِ حولَ فنِّ (الإتيكيت)، والمهاراتِ الشّخصيَّةِ، بالإضافة إلى ذلك، هي أيضًا طيَّارةٌ مُعترَفٌ بها.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1ba640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 63
// module chunks = 0